import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { ChronoDevisListPage } from "../../../../pages/chrono-devis-list-page/chrono-devis-list-page";
import { chronoDevisSearchSchema } from "../../../../pages/chrono-devis-list-page/chrono-devis-search-filters";

const chronoDevisSearchSchemaValidator = zodValidator(chronoDevisSearchSchema);

export const Route = createFileRoute("/_auth/_frame/chrono-devis/")({
  validateSearch: chronoDevisSearchSchemaValidator,
  component: ChronoDevisListPage,
});
